// Local translations
export const T = {
  en_GB: {
    duplicateField: "Duplicate Field",
    duplicateFieldDescription:
      "Create a new field with the same type, options and required setting, in the scope you choose. The copy is not placed on any page and has no sync keys.",
    fieldName: "Field Name",
    fieldNameRequired: "Field name is required",
    fieldScope: "Field Scope",
    globalScope: "Global (one value per flow)",
    goalScope: "Goal (one value per goal)",
    portfolioScope: "Portfolio (one value per portfolio)",
    cancel: "Cancel",
    duplicate: "Duplicate",
    failedToDuplicateField: "Failed to duplicate field",
  },
  nb_NO: {
    duplicateField: "Dupliser felt",
    duplicateFieldDescription:
      "Opprett et nytt felt med samme type, alternativer og obligatorisk-innstilling, i omfanget du velger. Kopien er ikke plassert på noen side og har ingen synkroniseringsnøkler.",
    fieldName: "Feltnavn",
    fieldNameRequired: "Feltnavn er obligatorisk",
    fieldScope: "Feltomfang",
    globalScope: "Global (én verdi per flyt)",
    goalScope: "Mål (én verdi per mål)",
    portfolioScope: "Portefølje (én verdi per portefølje)",
    cancel: "Avbryt",
    duplicate: "Dupliser",
    failedToDuplicateField: "Kunne ikke duplisere felt",
  },
} as const;
